import { IEnvClient, IEnvClientConfig } from '../interfaces/env.types';

export class EnvClient implements IEnvClient {
  public gameAPIEndpoint: string;
  public appBaseHref: string;
  public clientAppBaseHref: string;
  public debugMode: boolean;
  public isTestEnv: boolean;
  public isLocal: boolean;
  public isProduction: boolean;
  public matchMakingServer: string;

  public constructor() {
    this.gameAPIEndpoint = '';
    this.appBaseHref = '';
    this.clientAppBaseHref = '';
    this.debugMode = false;
    this.isTestEnv = false;
    this.isLocal = false;
    this.isProduction = false;
    this.matchMakingServer = '';
  }

  public init(config: IEnvClientConfig) {
    let cfg = config;

    if (!cfg.NODE_ENV) {
      throw new Error(`ENV VARIABLE "NODE_ENV" not set`);
    }

    this.isProduction = cfg.NODE_ENV.includes('production');

    if (cfg.NODE_ENV.startsWith('test')) {
      // replace environment numbers under test env
      const NODE_ENV_NUMBER: string = cfg.NODE_ENV.replace(/\D/g, '').padStart(2, '0');
      cfg = JSON.parse(JSON.stringify(cfg).replaceAll('<NODE_ENV_NUMBER>', NODE_ENV_NUMBER)) as IEnvClientConfig;
    }

    const { GAME_API, APP_BASE_HREF, CLIENT_APP_BASE_HREF, DEBUG_MODE, IS_LOCAL, IS_TEST_ENV, MATCH_MAKING_SERVER } = cfg;

    if (!GAME_API) {
      throw new Error(`ENV VARIABLE "GAME_API" not set`);
    }

    if (!APP_BASE_HREF) {
      throw new Error(`ENV VARIABLE "APP_BASE_HREF" not set`);
    }

    if (DEBUG_MODE === undefined) {
      throw new Error(`ENV VARIABLE "DEBUG_MODE" not set`);
    }

    if (IS_LOCAL === undefined) {
      throw new Error(`ENV VARIABLE "IS_LOCAL" not set`);
    }

    this.gameAPIEndpoint = GAME_API;
    this.appBaseHref = APP_BASE_HREF;

    if (IS_TEST_ENV === 'true') {
      this.isTestEnv = true;
      this.debugMode = localStorage.getItem('debugOverride') === 'true' || DEBUG_MODE === 'true';
    }
    else {
      this.debugMode = DEBUG_MODE === 'true';
    }

    this.isLocal = IS_LOCAL === 'true';
    if (this.isLocal) {
      // Only set the clientAppBaseHref if we are in local development mode
      this.clientAppBaseHref = CLIENT_APP_BASE_HREF || '';
    }

    if (MATCH_MAKING_SERVER !== undefined) {
      this.matchMakingServer = MATCH_MAKING_SERVER;
    }
  }

  public get props(): IEnvClient {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { init, use, ...rest } = this;
    return rest;
  }

  public use(config: IEnvClient) {
    Object.assign(this, config);
  }
}

export const envClient = new EnvClient();
